import React, { createContext, useState, useEffect } from 'react';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { DEVICE_ID, DEVICE_TYPE } from "../helpers/Constants";

export const DeviceContext = createContext("DeviceContext");

const DeviceContextProvider = ({ children }) => {

    const storedDeviceId = localStorage.getItem(DEVICE_ID);
    const storedDeviceType = localStorage.getItem(DEVICE_TYPE);
    const storedMaxDevices = localStorage.getItem('os-portal-max-devices');

    const [deviceId, setDeviceId] = useState(storedDeviceId);
    const [deviceType, setDeviceType] = useState(storedDeviceType);
    const [maxDevices, setMaxDevices] = useState(storedMaxDevices);
    const [loading, setLoading] = useState(!storedDeviceId);
    const [error, setError] = useState(null);

    const detectBrowser = () => {
        const userAgent = navigator.userAgent;
        let browser = 'Unknown';

        if (userAgent.indexOf('Firefox') > -1) {
            browser = 'Firefox';
        } else if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
            browser = 'Opera';
        } else if (userAgent.indexOf('Trident') > -1) {
            browser = 'Internet Explorer';
        } else if (userAgent.indexOf('Edge') > -1 || userAgent.indexOf('Edg') > -1) {
            browser = 'Edge';
        } else if (userAgent.indexOf('Chrome') > -1) {
            browser = 'Chrome';
        } else if (userAgent.indexOf('Safari') > -1) {
            browser = 'Safari';
        }

        return browser;
    };

    const getDeviceInfo = async () => {
        try {
            setLoading(true);

            // Get Browser Name
            const browser = detectBrowser();
            setDeviceType(browser);
            localStorage.setItem(DEVICE_TYPE, browser);

            // Get Device Fingerprint (unique for each device)
            const fp = await FingerprintJS.load();
            const result = await fp.get();
            setDeviceId(result.visitorId);
            localStorage.setItem(DEVICE_ID, result.visitorId);

            setError(null);
            setLoading(false);
        } catch (err) {
            setError(err);
            console.error('Error fetching device ID:', err);
            setLoading(false);
        }
    };

    useEffect(() => {
        // Only fetch if not already stored
        if (!storedDeviceId) {
            getDeviceInfo();
        }
    }, []);

    const clearDeviceInfo = () => {
        setDeviceId(null);
        setDeviceType(null);
        localStorage.removeItem(DEVICE_ID);
        localStorage.removeItem(DEVICE_TYPE);
    };

    return (
        <DeviceContext.Provider
            value={{
                deviceId,
                deviceType,
                maxDevices,
                loading,
                error,
                detectBrowser,
                getDeviceInfo,
                clearDeviceInfo
            }}
        >
            {children}
        </DeviceContext.Provider>
    );
}

export default DeviceContextProvider;
